import styled, { keyframes } from 'styled-components';
import { media, Row, Column } from '@simplywallst/ui-core';
import LogoBlackSVG from '@assets/images/logo/sws-logo-black.svg';
import {
  getCloudflareImageUrl,
  getStaticUrl,
} from '@/hooks/useCloudflareImage';
export const Wrapper = styled.div`
  overflow: hidden;
  height: 100vh;
  position: relative;
`;

export const Content = styled(Row)`
  z-index: 1;
  padding: ${({ theme }) => theme.x2spacePx}px;
  overflow: auto;
`;

export const Body = styled(Column)`
  max-width: 380px;
  padding: ${({ theme }) => theme.x2spacePx}px;
  ${media.smUp`
    padding: ${({ theme }) => theme.x5space * 10}px;
  `}
  background: white;
  margin-top: ${({ theme }) => theme.safeAreaInsetTop};
`;

interface BackgroundCoverImageProps {
  isZooming?: boolean;
}

const kenBurning = keyframes`
    100% {
      transform: scale3d(1.3, 1.3, 1.3) translate3d(0px, -12px, 0px);
    }
`;

export const BackgroundCoverImage = styled('div')<BackgroundCoverImageProps>`
  background-size: cover;
  background-position: center;
  background-image: url(${getCloudflareImageUrl({
    src: getStaticUrl('background-large.jpg'),
    width: 2560,
    quality: 60,
  })});
  @media (max-width: 1440px) and (min-width: 1025px) {
    background-image: url(${getCloudflareImageUrl({
      src: getStaticUrl('background-large.jpg'),
      width: 1440,
    })});
  }
  @media (max-width: 1024px) and (min-width: 769px) {
    background-image: url(${getCloudflareImageUrl({
      src: getStaticUrl('background-large.jpg'),
      width: 1024,
      fit: 'crop',
    })});
  }
  @media (max-width: 768px) {
    background-image: url(${getCloudflareImageUrl({
      src: getStaticUrl('background-large.jpg'),
      width: 768,
      fit: 'crop',
      quality: 30,
    })});
  }
  transform-origin: 50% 30%;
  animation: ${kenBurning} 90s linear infinite;
  animation-direction: alternate;
  background-size: cover;
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &:after {
    position: absolute;
    display: block;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(20, 28, 37, 0.6);
  }
`;

export const SWSLogo = styled(LogoBlackSVG)`
  max-width: 160px;
  margin: 0 auto;
  margin-bottom: ${({ theme }) => (theme.x1space + 0.4) * 10}px;
  ${media.mdUp`
    max-width: 180px;
    margin-bottom: ${({ theme }) => theme.x3spacePx}px;
  `}
  display: block;
`;
